import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
const notifications = [{
  name: 'Camila T.',
  city: 'Santiago',
  item: 'Kit Completo 🏆',
  time: 'hace 8 minutos'
}, {
  name: 'Valentina R.',
  city: 'Viña del Mar',
  item: 'Kit Base',
  time: 'hace 15 minutos'
}, {
  name: 'Sofía M.',
  city: 'Concepción',
  item: 'Kit Completo 🏆',
  time: 'hace 22 minutos'
}, {
  name: 'Javiera C.',
  city: 'Antofagasta',
  item: 'Kit Completo 🏆',
  time: 'hace 31 minutos'
}, {
  name: 'Daniela P.',
  city: 'Temuco',
  item: 'Kit Base',
  time: 'hace 45 minutos'
}];
export function PurchaseNotification() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [hasBeenDismissed, setHasBeenDismissed] = useState(false);
  useEffect(() => {
    if (hasBeenDismissed) return;
    // Initial delay before showing first notification
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Cycle notifications every 15 seconds
    const cycleInterval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % notifications.length);
        setIsVisible(true);
      }, 1000); // Wait 1s before showing the next one
    }, 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(cycleInterval);
    };
  }, [hasBeenDismissed]);
  if (hasBeenDismissed) return null;
  const current = notifications[currentIndex];
  return <AnimatePresence data-id="element-219">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 25
    }} className="fixed bottom-24 md:bottom-6 left-4 md:left-6 z-50 bg-white rounded-xl shadow-soft-lg border border-gray-100 p-4 pr-10 max-w-[300px] flex items-start gap-3" data-id="element-220">
          <button onClick={() => {
        setIsVisible(false);
        setHasBeenDismissed(true);
      }} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 p-1" aria-label="Cerrar notificación" data-id="element-221">
            <X className="w-4 h-4" data-id="element-222" />
          </button>

          <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center shrink-0 mt-0.5" data-id="element-223">
            <span className="text-green-600 text-lg" data-id="element-224">✓</span>
          </div>

          <div data-id="element-225">
            <p className="text-xs text-gray-500 mb-0.5" data-id="element-226">Compra verificada</p>
            <p className="text-sm font-medium text-gray-900 leading-tight mb-1" data-id="element-227">
              {current.name} de {current.city}
            </p>
            <p className="text-xs text-ocean-teal-dark font-medium" data-id="element-228">
              compró {current.item}
            </p>
            <p className="text-[10px] text-gray-400 mt-1" data-id="element-229">{current.time}</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}